import { PartnerOptionalParams, PartnerOverview } from '../../models/partner';
import { customerHubHttp } from '../customer-hub-api';

export const getPartners = async (
  country: string,
  optionalParams?: PartnerOptionalParams,
  abortController?: AbortController
): Promise<PartnerOverview[]> => {
  try {
    const urlParams = new URLSearchParams({ country });

    if (optionalParams?.companyName) urlParams.append('companyName', optionalParams.companyName);
    if (optionalParams?.location) urlParams.append('location', optionalParams.location);
    if (optionalParams?.expertise) urlParams.append('expertise', optionalParams.expertise);

    const url = `/jabra-locator/partners?${urlParams.toString()}`;

    const response = await customerHubHttp.get<PartnerOverview[]>(url, {
      signal: abortController?.signal,
    });

    return response?.data ?? [];
  } catch (error) {
    console.error(`Error fetching partners:`, error);
    return [];
  }
};
